import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@altertec_gparn/lib";
import { certificationsProjectsRoutes } from "@/router/auth/certifications-projects.routes";
import { certificationsDossierRoutes } from "@/router/auth/certifications-dossier.routes";
import { certificationsDeliveriesRoutes } from "@/router/auth/certifications-deliveries.routes";

export default {
  path: "/certifications",
  name: "Certifications View",
  meta: { sectionAccess: "CERTIFICATIONS", redirects: true },
  component: () => import("@/layouts/EmptyLayout.vue"),
  children: [
    {
      path: "entry",
      name: "Certifications Section Entry",
      redirect: { name: "Certification List" },
      meta: { permissions: [PermissionEnum.CERTIFICATIONS_PROJECTS] },
    },
    certificationsDossierRoutes,
    certificationsProjectsRoutes,
    certificationsDeliveriesRoutes,
    {
      path: "configuration",
      name: "Certifications Configuration",
      redirect: { name: "Certifications Client Groups" },
      meta: { permissions: [PermissionEnum.CONFIGURATION_COMMERCIAL] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "client-groups/:type?/:id?",
          name: "Certifications Client Groups",
          component: () => import("@/views/auth/configuration/ClientGroups.vue"),
          props: true,
        },
        {
          path: "banks/:type?/:id?",
          name: "Certifications Banks",
          component: () => import("@/views/auth/configuration/Banks.vue"),
          props: true,
        },
        {
          path: "client-types/:type?/:id?",
          name: "Certifications Client Types",
          component: () => import("@/views/auth/configuration/ClientTypes.vue"),
          props: true,
        },
        {
          path: "client-payment-methods/:type?/:id?",
          name: "Certifications Client Payment Methods",
          component: () => import("@/views/auth/configuration/ClientPaymentMethods.vue"),
          props: true,
        },
        {
          path: "client-condition-codes/:type?/:id?",
          name: "Certifications Client Condition Codes",
          component: () => import("@/views/auth/configuration/ClientConditionCodes.vue"),
          props: true,
        },
        {
          path: "clients/:type?/:id?",
          name: "Certifications Clients",
          component: () => import("@/views/auth/configuration/Clients.vue"),
          props: true,
          children: [
            {
              path: "import",
              name: "Certifications Clients Import",
              components: {
                sidebar: () => import("@/modules/clients/components/sidebars/ImportClientsSidebar.vue"),
              },
            },
          ],
        },
        {
          path: "contacts/:type?/:id?",
          name: "Certifications Contacts",
          component: () => import("@/views/auth/configuration/Contacts.vue"),
          props: true,
        },
        {
          path: "accounting-accounts/:type?/:id?",
          name: "Certifications Accounting Accounts",
          component: () => import("@/views/auth/configuration/AccountingAccounts.vue"),
          props: true,
        },
        {
          path: "certification-valuation-accounting-configuration",
          name: "Certifications Valuation Accounting Configuration",
          component: () => import("@/views/auth/configuration/CertificationValuationAccountingConfiguration.vue"),
        },
      ],
    },
  ],
} as RouteRecordRaw;
